// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uOs8","icon":"styles_icon__1gqap"};